import { Epic } from "redux-observable";
import { switchMap, filter } from "rxjs/operators";
import { Observable } from "rxjs";
import { IState, Dependencies } from "../@types";
import { RootAction } from "../actions";
import { isActionOf } from "typesafe-actions";
import { usersActions, usersActionsAsync } from "../actions/usersActions";
import { appActions } from "../actions/appActions";
import { Auth } from "aws-amplify";


export const editUserEpic: Epic<
    RootAction,
    RootAction,
    IState,
    Dependencies
> = (action$, state$, dependencies) => {
    return action$.pipe(
        filter(isActionOf(usersActionsAsync.editUser.request)),
        switchMap(action => {
            return new Observable<RootAction>(observer => {
                const state = state$.value as IState;
                const { apiGatewayUrl } = state.constants;
                const { user, userId } = action.payload;
                const currentUser = state.users.user;
                async function editUser() {
                    const session = await Auth.currentSession();
                    const token = session.getIdToken().getJwtToken();

                    const updatedUser = await dependencies.usersApi.editUser({
                        apiGatewayUrl,
                        token,
                        userId,
                        user
                    });
                    observer.next(usersActionsAsync.editUser.success({ user: updatedUser }));
                    if (currentUser?.userId === userId) {
                        observer.next(usersActions.updateSelf(updatedUser));
                        observer.next(appActions.setMessage({ message: "Update success", severity: "success"}));
                    }
                }
                editUser().catch(error => {
                    console.log(error);
                    observer.next(usersActionsAsync.editUser.failure({ error }));
                    observer.next(appActions.setMessage({ message: "Update failed, Please try again later", severity: "error"}))
                });
            });
        })
    );
}